export default "__VITE_ASSET__c20decff__"